<template>
    <layout-user containerClass="bg-white">
        <form autocomplete="off" @submit.prevent="reset" method="post" data-vv-scope="form">
            <div class="row mt-2 mt-sm-0 mb-4">
                <div class="col-sm-12">
                    <h1 class="title text-center text-sm-left">{{this.pageTitle}}</h1>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-sm-12">
                    <MaterialInput type="text" class="city-form-group city-bg form-xl" id="input-email" name="email" v-model.trim="form.email" v-validate="'required|email'" :inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.email',this)}]" :error="errors.first('form.email')" :disabled="true">Email</MaterialInput>

                    <MaterialInput ref="password" type="password" class="city-form-group city-bg form-xl" id="input-password" name="password" v-model.trim="form.password" v-validate="{required: true, min: getMinPasswordLength()}" :inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.password',this)}]" :error="errors.first('form.password')">Nova Password</MaterialInput>

                    <MaterialInput type="password" class="city-form-group city-bg form-xl" id="input-confirmPassword" name="confirmPassword" v-model.trim="form.confirmPassword" v-validate="'required|confirmed:password'" :inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.confirmPassword',this)}]" :error="errors.first('form.confirmPassword')">Confirmar Nova Password</MaterialInput>
                </div>
            </div>
            <div class="row justify-content-center pt-sm-3">
				<div class="col-12 col-sm-6 mx-0 order-2 order-sm-1">
					<router-link
						:to="{ name: 'portal.login' }"
						class="btn btn-outline-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block">
						{{ this.cancelTitle }}
					</router-link>
				</div>
				<div class="col-12 col-sm-6 mx-0 order-1 order-sm-2">
					<button
						class="btn btn-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block mb-3 mb-sm-0 text-nowrap"
						type="submit"
						:disabled="isDisabled">
						{{ this.submitTitle }}
					</button>
				</div>
			</div>
        </form>
    </layout-user>
</template>

<script>
    import mixin from '../../mixin'
    import LayoutUser from '../../layouts/User.vue'

    export default {
        mixins: [mixin],
        components: {
            'layout-user': LayoutUser,
        },
        data()
        {
            return {
                pageID: 'resetpassword',
                pageTitle: 'Alterar password',
                submitTitle: 'Gravar',
                cancelTitle: 'Cancelar',
                form: {
                    email            : this.$route.params.email,
                    password         : null,
                    confirmPassword  : null,
                }
            }
        },
        methods: {
            reset()
            {

                //this.$root.$helper.messpasswordges.removeToast();

                this.$validator.validateAll('form').then(result =>
                {
                    if(!result) {
                        this.showError('Por favor corrija os erros no formulário', this.pageTitle);
                        return;
                    }

                    var _this = this;
                    this.$http.post(this.url.reset,
                    {
                        token: this.$route.params.token,
                        email: this.form.email,
                        password: this.form.password,
                        password_confirmation: this.form.confirmPassword
                    })
                    .then(res =>
                    {
                        this.showMessage(res.data.data, this.pageTitle, 'success', () =>
                        {
                            _this.$router.push({name: 'portal.login'})
                        });
                    })
                    .catch(error =>
                    {
                        this.showHttpError(error);
                    });
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .reset-password{
        padding-left:0px;
    }
</style>